import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  CLINICS_ENROLL_PSR_AND_CLINIC_BEGIN,
  CLINICS_ENROLL_PSR_AND_CLINIC_SUCCESS,
  CLINICS_ENROLL_PSR_AND_CLINIC_FAILURE,
  CLINICS_ENROLL_PSR_AND_CLINIC_DISMISS_ERROR,
} from './constants';
import ApiService from '../../../common/services/ApiService';

export function enrollPsrAndClinic(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CLINICS_ENROLL_PSR_AND_CLINIC_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      ApiService.enrollPsrAndClinic(args).then(
        (res) => {
          dispatch({
            type: CLINICS_ENROLL_PSR_AND_CLINIC_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CLINICS_ENROLL_PSR_AND_CLINIC_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissEnrollPsrAndClinicError() {
  return {
    type: CLINICS_ENROLL_PSR_AND_CLINIC_DISMISS_ERROR,
  };
}

export function useEnrollPsrAndClinic() {
  const dispatch = useDispatch();

  const { enrollPsrAndClinicPending, enrollPsrAndClinicError } = useSelector(
    state => ({
      enrollPsrAndClinicPending: state.clinics.enrollPsrAndClinicPending,
      enrollPsrAndClinicError: state.clinics.enrollPsrAndClinicError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(enrollPsrAndClinic(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissEnrollPsrAndClinicError());
  }, [dispatch]);

  return {
    enrollPsrAndClinic: boundAction,
    enrollPsrAndClinicPending,
    enrollPsrAndClinicError,
    dismissEnrollPsrAndClinicError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CLINICS_ENROLL_PSR_AND_CLINIC_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        enrollPsrAndClinicPending: true,
        enrollPsrAndClinicError: null,
      };

    case CLINICS_ENROLL_PSR_AND_CLINIC_SUCCESS:
      // The request is success
      return {
        ...state,
        enrollPsrAndClinicPending: false,
        enrollPsrAndClinicError: null,
      };

    case CLINICS_ENROLL_PSR_AND_CLINIC_FAILURE:
      // The request is failed
      return {
        ...state,
        enrollPsrAndClinicPending: false,
        enrollPsrAndClinicError: action.data.error,
      };

    case CLINICS_ENROLL_PSR_AND_CLINIC_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        enrollPsrAndClinicError: null,
      };

    default:
      return state;
  }
}
